export const CONFIG = {
  API_BASE: process.env.REACT_APP_API_BASE || "http://localhost:8080/v1",
  GOOGLE_API_KEY: process.env.REACT_APP_GOOGLE_API_KEY || "",
  MINUTES_FOR_DEVICE_TO_CALL_IN: 10,
  STANDARD_DATETIME_FORMAT: "MM/DD/YYYY h:mma",
};
